<template>
    <div class="payment__form">
        <form
            v-if="state.currentView == 'IBANK_INIT_VIEW' && state.processing != true"
            @submit.prevent="checkBank"
        >
            <p class="container__col-md-12 container__col-sm-12 payment__instruction">
                {{$t("ib.init.instruction")}}
            </p>
            <primary-select
                :title="$t('ib.input.bank')"
                :description-text="$t('ui.input.choose')"
                :isRequired="getValueFromPath(state, 'inputs.bank.required') || true"
                @value-change="bank = $event"
                inputName="bankÏ"
                :options="state.banks"
            />

            <primary-input
                :title="$t('ib.input.account')"
                type="tel"
                v-if="getValueFromPath(state, 'inputs.account_number') || false"
                class="container__col-md-12 container__col-sm-12"
                :isRequired="
                    getValueFromPath(state, 'inputs.account_number.required') || true
                "
                inputName="account_number"
                prefix-image="account-number"
                placeholder="0123456789"
                @value-change="accountNumber = $event"
            />
            <primary-input
                :title="$t('ib.input.id')"
                class="container__col-md-12 container__col-sm-12"
                :isRequired="
                    getValueFromPath(state, 'inputs.account_id.required') || true
                "
                inputName="account_id"
                prefix-image="credit-card"
                placeholder="0123456789"
                @value-change="accountID = $event"
            />
            <primary-input
                :title="$t('ib.input.password')"
                class="container__col-md-12 container__col-sm-12"
                :isRequired="
                    getValueFromPath(state, 'inputs.account_password.required') || true
                "
                inputName="account_password"
                prefix-image="smart-phone"
                placeholder="0800000000"
                @value-change="password = $event"
            />
            <PrimaryButton
                type="submit"
                :content="
                    [$t('ui.pay.btn'), state.currency, state.amount.toLocaleString()]
                        .filter(Boolean)
                        .join(' ')
                "
            />
        </form>
    </div>
</template>
<script>
import { ref, watch, onBeforeUnmount } from "vue";
import { injectStore, mapState } from "redux-vuex";
import { getValueFromPath } from "@/support/helpers";

import PrimarySelect from "@/components/form/base-select";
import PrimaryButton from "@/components/form/base-button";
import PrimaryInput from "@/components/form/base-input";
export default {
    name: "BankPayment",
    components: {
        PrimaryInput,
        PrimaryButton,
        PrimarySelect,
    },
    setup() {
        const store = injectStore();
        const bank = ref("");
        const checkoutData = ref(store.getState());
        const transactionSuccessful = ref(false);
        const password = ref();
        const accountID = ref();
        const accountNumber = ref(
            getValueFromPath(
                checkoutData.value,
                "view.context.inputs.account_number.value",
            ) || null,
        );
        const subscription = store.subscribe(() => {
            checkoutData.value = store.getState();
        });
        watch(bank, (newVal, OldVal) => {
            if (newVal !== "" && OldVal !== null && newVal !== OldVal) {
                const data = { bank: newVal };
                checkoutData.value.view.context.$actions.update(data);
            }
        });
        function Next() {
            setTimeout(() => {
                checkoutData.value.view.context.$actions.next();
            }, 0);
        }
        function checkBank() {
            if (bank.value != "" && accountID.value != "") step2();
        }
        function step2() {
            const data = { account_number: accountID.value };
            checkoutData.value.view.context.$actions.update(data);
            Next();
        }
        onBeforeUnmount(() => {
            subscription();
        });
        return {
            state: mapState({
                currency: (state) =>
                    getValueFromPath(state, "currency.current") || null,
                amount: (state) => getValueFromPath(state, "amount") || null,
                processing: (state) => getValueFromPath(state, "processing") || false,
                currentView: (state) => getValueFromPath(state, "view.current") || null,
                banks: (state) =>
                    getValueFromPath(state, "view.context.inputs.bank.options") || [],
                inputs: (state) => getValueFromPath(state, "view.context.inputs") || {},
            }),
            checkoutData,
            bank,
            accountNumber,
            accountID,
            password,
            getValueFromPath,
            transactionSuccessful,
            step2,
            Next,
            checkBank,
        };
    },
};
</script>

<style scoped>
</style>